import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EmployeesApiService } from 'src/app/core/employees-api/employees-api.service';
import Employee from 'src/app/service/model/Employee';
import EmploymentRoleType from 'src/app/service/model/EmploymentRoleType';

@Component({
  selector: 'mandates-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
})
export class EmployeesComponent implements OnInit, OnDestroy {
  employees: Employee[];
  admins: Employee[];
  coworker: Employee[];

  private destroy$ = new Subject<void>();

  constructor(private employeesApiService: EmployeesApiService) {
    this.employeesApiService.getEmployees().subscribe();
  }

  ngOnInit(): void {
    this.employeesApiService.employees$
      .pipe(takeUntil(this.destroy$))
      .subscribe((employees) => {
        this.employees = employees;
        this.admins = employees.filter((e) => e.role === EmploymentRoleType.ADMIN);
        this.coworker = employees.filter((e) => e.role === EmploymentRoleType.COWORKER);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
